<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    :close-on-click-modal="false"
    :title="$t('notice.新增公告')"
    class="dialog-dark"
    width="400px"
    append-to-body
    @close="onClose"
  >
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="80px">
      <el-form-item :label="$t('notice.公告内容')" prop="content">
        <el-input
          v-model="ruleForm.content"
          :placeholder="$t('notice.请输入备注')"
          class="input-textarea"
          type="textarea"
          show-word-limit
          maxlength="140"
          resize="none"
          rows="5"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button
        :disabled="!ruleForm.content"
        class="button-mini"
        type="primary"
        size="mini"
        plain
        @click="publish(1)"
        >{{ $t("notice.暂不发布") }}</el-button
      >
      <el-button
        :disabled="!ruleForm.content"
        class="button-mini"
        type="primary"
        size="mini"
        @click="publish(0)"
        >{{ $t("notice.立即发布") }}</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { Form, FormItem } from "element-ui";
import { mapGetters } from "vuex";
export default {
  name: "Cement",
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
  },
  data() {
    return {
      visible: true,
      ruleForm: {
        content: "",
      },
    };
  },
  computed: {
    ...mapGetters(["liveRoomStatus"]),
    rules() {
      return {
        content: [
          {
            required: true,
            message: this.$t("notice.请输入公告内容"),
            trigger: "blur",
          },
          {
            min: 0,
            max: 140,
            message: this.$t("notice.长度在 0 到 140 个字符"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    onClose() {
      this.$refs.ruleForm.resetFields();
    },
    publish(type) {
      if (type == 0) {
        if (this.liveRoomStatus != 2) {
          return this.$message.warning(this.$t("common.请先开启直播"));
        }
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("action", {
            type,
            content: this.ruleForm.content,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-dark {
  ::v-deep {
    .el-form-item__label {
      line-height: 24px;
      font-size: 12px;
      color: #fff;
    }
    .el-textarea__inner {
      height: 100px;
      padding-bottom: 24px;
      border-color: #525366;
    }
    .el-textarea .el-input__count {
      color: #acb2bf;
      left: 10px;
      right: 20px;
      text-align: right;
      background: #212442;
      bottom: 1px;
      padding-bottom: 4px;
    }
  }
}
</style>
